/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Loaderror3Inputs */

const en_coinvestments_dataroom_loaderror3 = /** @type {(inputs: Coinvestments_Dataroom_Loaderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load data room`)
};

/**
* | output |
* | --- |
* | "Failed to load data room" |
*
* @param {Coinvestments_Dataroom_Loaderror3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_loaderror3 = /** @type {((inputs?: Coinvestments_Dataroom_Loaderror3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Loaderror3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_loaderror3(inputs)
});
export { coinvestments_dataroom_loaderror3 as "coInvestments_dataRoom_loadError" }